const dropdownItemWrapperClasses = 'flex flex-col gap-4';

const dropdownItemLinkClasses = 'flex items-start gap-3';
const dropdownItemLinkTextClasses = 'flex flex-col gap-1';
const dropdownItemLinkNameClasses = 'site-paragraph-m font-bold';
const dropdownItemLinkDescriptionClasses = 'site-paragraph-m text-site-neutrals-900';
const dropdownItemLinkFeaturedClasses = '!text-site-primary-600';

/**
 * MobileFlyoutDropdownMenu Theme
 */

const mobileFlyoutDropdownMenuSiteTheme = {
  dropdownItemWrapperClasses,
  dropdownItemLinkClasses,
  dropdownItemLinkTextClasses,
  dropdownItemLinkNameClasses,
  dropdownItemLinkDescriptionClasses,
  dropdownItemLinkFeaturedClasses,
};

/**
 * Exports
 */

export default mobileFlyoutDropdownMenuSiteTheme;
